import { Component, OnInit } from "@angular/core";

import { ReportTableComponent } from "../reporttable.component";

import { AlertService } from "../../util/alert/alert.service";
import { SharedService } from "../../home/shared.service";
import { ReportService } from "../report.service";
import { Report } from "../report.model";

@Component({
	selector: "app-task-report",
	templateUrl: "./taskreport.component.html"
})
export class TaskReportComponent extends ReportTableComponent implements OnInit {
	public report: Report;
	public excelData: any[];
	public columns: Array<any> = [
		{
			title: "Task",
			name: "Task",
			filtering: { filterString: "" }
		},
		{
			title: "Tags",
			name: "Tags",
			filtering: { filterString: "" }
		}
	];

	private serverResultData: Array<any> = [];

	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: "" },
		className: ["table-striped", "table-bordered"]
	};

	constructor(
		private alertService: AlertService,
		private sharedService: SharedService,
		private reportService: ReportService
	) {
		super();
		this.report = this.reportService.getSelectedReport();
	}

	ngOnInit() {
		this.loadTasks(this.report.reportData);
	}

	loadTasks(data: any) {
		this.excelData = [];
		for (let i = 0; i < data.length; i++) {
			this.data.push({
				Task: data[i].Task,
				Tags: data[i].TagNames != null ? data[i].TagNames : ""
			});

			// this.excelData.push({
			//   Task: data[i].Task,
			//   Tags: data[i].TagNames != null ? data[i].TagNames : ""
			// });
		}
		this.serverResultData = data;
		//  this.report.reportDataList = this.excelData;
		this.report.columns = this.columns;
		this.config.report = this.report;
		this.pageCount = Math.ceil(
			this.serverResultData.length / this.itemsPerPage
		);
		//	console.log(JSON.stringify(this.serverResultData));
		this.onChangeTable(this.config);
	}

	public onCellClick(data: any): any { }
}
